module.exports = __webpack_public_path__ + "img/home-hack-person.c6ea6953.svg";